/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ThirdPartyAudienceListPageComponent} from './third-party-audience-list-page.component';

@Component({
  standalone: true,
  imports: [ThirdPartyAudienceListPageComponent],
  selector: 'adn-third-party-audience-route-page',
  template: `
    <adn-third-party-audience-list-page [readOnly]="readOnly"></adn-third-party-audience-list-page>
  `
})
export class ThirdPartyAudienceRoutePageComponent {
  @Input() readOnly = false;
}
